module.exports = __webpack_public_path__ + "img/resource_04.ad91182f.png";